'use client';

import styles from './styles/modals.module.css';

export default function EditModal({
  isOpen,
  onClose,
  editContent,
  setEditContent,
  onSave,
  sectionName
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <span className={styles.close} onClick={onClose}>&times;</span>
        <h2>Edit {sectionName}</h2>
        <textarea
          className={styles.formInput}
          style={{ whiteSpace: 'pre-wrap' }}
          value={editContent}
          onChange={(e) => setEditContent(e.target.value)}
        />
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          onClick={onSave}
          style={{ marginTop: '1rem' }}
        >
          Save
        </button>
      </div>
    </div>
  );
}